<template>
	<div class='nameA'>
		<header id="header">
			<ul>
				<li v-for="(item, index) in c_header" :key="index">
					<div :class="item.active && 'active'" @click="handleScrollTo(index)">{{item.title}}</div>
				</li>
			</ul>
		</header>
		<div class="plate_box">
			<div :class="handlePlateStyle(item)" v-for="(item, index) in page_data" :key="index">

				<div class="content_box index" :style="{backgroundImage: `url('${item.plate_info.background}')`}" v-if="item.type == 'index'">
					<div class="topImg" v-if="item.plate_info.topImg">
						<img :src="item.plate_info.topImg" alt="">
					</div>
					<div class="index_content" v-else>
						<div class="index_title_box">
							<div class="title_from">
								<pre>{{item.plate_info.name}}</pre>
								<pre>{{item.plate_info.name1}}</pre>
							</div>
							<div class="title_logo">
								<img :src="item.plate_info.title_logo" alt="">
							</div>
							<div class="title_name">
								<pre>{{item.plate_info.topDescribe}}</pre>
								<pre>{{item.plate_info.topDescribe1}}</pre>
							</div>
						</div>

						<div class="plate_info_box">
							<div v-for="(jtem, jndex) in item.plate_info.desc" :key="jndex">
								<div class="label">{{jtem.label}}：</div>
								<div class="value">
									<pre>{{jtem.value}}</pre>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="content_box" :id="`content_box_${index - 1}`" :style="{backgroundImage: `url('${page_data[0].plate_info.background}')`}" v-else-if="item.type == 15">
					<div class="title_box" v-if="item.isTitleHide == 1">
						<span>{{item.title}}</span>
					</div>

					<SecondaryColumn :list="item.list" />
				</div>

				<SecondaryColumn :list="item.list" v-else />

			</div>
		</div>

		<footer v-if="page_data[0] && page_data[0].plate_info.footDescribe">
			<div class="content">
				<!-- <div v-html="footer_text.replace(/\n/g, '<br>')"></div> -->
				<div v-html="page_data[0].plate_info.footDescribe"></div>
			</div>
		</footer>
	</div>
</template>
<script>
import SecondaryColumn from "@/components/shares/SecondaryColumn/template_red/index.vue";
import ShareService from "@/service/ShareService.js";

export default {
	name: "nameA",
	components: {
		SecondaryColumn,
	},
	data() {
		return {
			page_data: [],
		};
	},
	computed: {
		c_header: function () {
			return this.page_data.filter((i) => i.title && i.title) || [];
		},
		// swiper_pic_text() {
		// 	return this.$refs.swiper_pic_text[0].$swiper
		// }
	},
	async mounted() {
		const {
			page_data,
			share: { name, desc, vertical_cover_url, share_url },
		} = await new ShareService().Data(this.$route.query.id);
		document.title = name;

		this.page_data = page_data;

		const wxShareInfo = {
			title: name,
			info: desc,
			img: vertical_cover_url,
			// shareurl: share_url || this.$route.path.replace('/detail', '').replace('/list', '').replace('/videolist', ''),
			shareurl: window.location.href,
		};
		this.$WXConfig.wxShowMenu({
			ifshare: true,
			that: this,
			data: wxShareInfo,
		});
	},
	methods: {
		handleScrollTo(index) {
			const headerOffsetHeight =
				document.getElementById("header").offsetHeight;
			const elTop = document.getElementById(
				`content_box_${index}`
			).offsetTop;
			window &&
				window.scroll({
					top: elTop - headerOffsetHeight,
					behavior: "smooth",
				});

			let list_data = this.page_data.map(i => ({...i, active: false}))
			list_data[index + 1].active = true

			this.page_data = list_data
		},
		handlePlateStyle(item) {
			if (item.type == "index") {
				// console.log(item);
			}
		},
	},
};
</script>
<style lang='stylus' scoped>
.nameA
	width 100%

	header
		width 100%
		height 1.07rem
		background-color #F76370
		position fixed
		top 0
		z-index 100

		ul
			width calc(100% - 1.34rem)
			height 100%
			margin auto
			display flex
			justify-content flex-start
			align-items center
			overflow-x overlay

			&::-webkit-scrollbar				// 滚动条整体部分
				display none
				height 12px
				// background-color: #67CBFF
				background-color: rgba(0,0,0, 0.1)
			&::-webkit-scrollbar-thumb     	// 滚动条里的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
				background-color: rgba(#A40000, 0.5)
				border-radius: 6px

			li
				margin 0 0.2rem
				display flex
				justify-content space-around
				align-items center

				&:first-child
					margin-left 0

				div
					font-size 0.32rem
					font-family Microsoft YaHei
					font-weight 400
					line-height 0.96rem
					color #F76370
					width 1.87rem
					height 0.64rem
					background-color #A40000
					box-sizing border-box
					border-radius 0.32rem
					display flex
					justify-content space-around
					align-items center
					cursor pointer

				.active
					color #fff

	.plate_box
		width 100%

		.content_box
			width 100%
			padding-bottom 1.07rem
			background-color #5D5D5D
			background-size 100%

			&>.title_box
				width calc(100% - 1.34rem)
				height 0.8rem
				margin auto
				margin-bottom: 0.8rem
				background-image url('../../../assets/images/shares/template_red/plate_title.png')
				background-repeat no-repeat
				background-size 100%
				display flex
				justify-content flex-start
				align-items center

				span
					font-size 0.43rem
					font-family Microsoft YaHei
					font-weight bold
					line-height 0.96rem
					color #EEEEEE
					margin-left 1.07rem

		.index
			// background-image: url('../../../assets/images/shares/template_red/index_bg.png')
			background-size cover
			margin-top 1.07rem
			padding-top 0.8rem
			padding-bottom 2.61rem

			.topImg
				width 100%
				// height 19.4rem

				img
					width 100%
					height 100%

			.index_content
				width calc(100% - 1.34rem)
				margin auto

				.index_title_box
					display flex
					flex-direction column
					justify-content flex-start
					align-items center

					.title_from
						font-size 0.37rem
						font-family Microsoft YaHei
						font-weight 400
						line-height 0.96rem
						color #fff
						text-align center
						line-height 0.48rem

					.title_logo
						width 2.4rem
						// height 2.4rem
						// background-image: url('../../../assets/images/shares/template_red/index_logo.png')
						margin-top 1rem

					.title_name
						font-size 0.64rem
						font-family Microsoft YaHei
						font-weight bold
						line-height 0.85rem
						color #fff
						margin-top 0.56rem
						text-align center

				.plate_info_box
					margin-top 3rem

					div
						margin-top 0.4rem
						display flex
						justify-content flex-start

						.label
							font-size 0.32rem
							font-family Microsoft YaHei
							font-weight 400
							line-height 0.48rem
							color #F76370
							text-align right
							display block
							width 1.7rem
							margin-right 0.3rem

						.value
							font-size 0.32rem
							font-family Microsoft YaHei
							font-weight 400
							line-height 0.48rem
							color #F76370
							width calc(100% - 2rem)
							text-align left

	footer
		width 100%
		background-color #333
		font-size 0.32rem
		font-family Microsoft YaHei
		font-weight 400
		line-height 0.48rem
		color #D5D5D5
		text-align center
		padding 0.56rem 0.72rem

@media (min-width 750px)
	body
		width 750px
		margin auto

		.nameA
			header
				width 750px
				overflow hidden
</style>
